import { DynamicForm } from "../../cpn/render-cpn/render";

export const SearchComponent = ({ fields, onSearch = () => {}, ...props }) => {
  return (
    <>
      <DynamicForm
        props={props}
        data={fields}
        onFormDataChange={() => {}}
        onFormSubmit={(payload) => {
          const payload_mapped = {};
          for (const k in payload) {
            for (const i in payload[k]) {
              payload_mapped[`${k}.${i}`] = payload[k][i];
            }
          }

          // for (const i in payload) {
          //   const { tables } = payload[i];
          //   for (const table in tables) {
          //     for (const k in tables[table]) {
          //       if (typeof tables[table][k] === "object") {
          //         const keys = Object.keys(tables[table][k]);
          //         const isFrom = keys.includes("from");
          //         const isTo = keys.includes("to");
          //         if (isFrom || isTo) {
          //           if (!tables[table][k].from && !tables[table][k].to) {
          //             delete tables[table][k];
          //           }
          //         }
          //       }
          //       if (!tables[table][k]) {
          //         delete tables[table][k];
          //       }
          //     }
          //   }
          //   payload_mapped.push(payload[i]);
          // }
          onSearch({
            data: payload_mapped,
            charts: props.charts.map(({ value }) => value),
          });
        }}
        onFormReset={() => {}}
      />
    </>
  );
};
